import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import AddressForm from '../components/AddressForm/AddressForm';
import Navbar from '../components/Navbar/Navbar';
import '../styles/style.css';

const Home = () => {
    const location = useLocation();
    const [preloadedAddresses, setPreloadedAddresses] = useState([]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const result = [];
        let current = null;

        for (const [key, value] of queryParams.entries()) {
            if (key === 'network') {
                if (current && (current.address || current.network)) {
                    result.push(current);
                }
                current = {network: value, address: ''};
            } else if (key === 'address') {
                if (!current) {
                    current = {network: 'Ethereum', address: value};
                } else {
                    current.address = value;
                }
            }
        }
        if (current && (current.address || current.network)) {
            result.push(current);
        }

        const cleaned = result
            .filter(r => r.address && r.network)
            .filter(
                (v, i, arr) =>
                    arr.findIndex(
                        x =>
                            x.address.toLowerCase() === v.address.toLowerCase() &&
                            x.network === v.network,
                    ) === i,
            );

        setPreloadedAddresses(cleaned);
    }, [location.search]);

    const handleScan = () => {
    };

    return (
        <div className='home-container'>
            <Navbar/>
            <h1 className='home-title'>Level-2 Blockchain Explorer</h1>
            <AddressForm
                onScan={handleScan}
                preloadedAddresses={preloadedAddresses}
            />
        </div>
    );
};

export default Home;

